import React, { useEffect, useState } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import { BrowserRouter as Router, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import {
  FaArrowLeft,
  FaArrowRight,
  FaInfoCircle,
  FaMinusCircle,
} from "react-icons/fa";
import Select from "react-select";
import "flatpickr/dist/flatpickr.min.css";
import "flatpickr/dist/themes/material_green.css";
import { addDays, format, getDay, isValid, parse } from "date-fns";
import moment from "moment";
import fr from "date-fns/locale/fr";
import ConnectMessage from "./ConnectMessage";
import { InputMask } from "@react-input/mask";
import { checkAge } from "../pages/SharedData/utils";
import { ApiUrl } from "../config";
import { useTranslation } from "react-i18next";
registerLocale("fr", fr);

const ContactAreaFour = () => {
  const { t } = useTranslation();

  //Enfant Part
  const [currentStepEnf, setCurrentStepEnf] = useState(1);
  const [nomEnf, setNomEnf] = useState("");
  const [prenomEnf, setPrenomEnf] = useState("");
  const [dateNaissanceEnf, setDateNaissanceEnf] = useState(null);
  const [selectedGendre, setSelectedGendre] = useState(null);
  const gendres = [
    { value: "fille", label: "Fille" },
    { value: "garcon", label: "Garçon" },
  ];

  const [nomTut, setNomTut] = useState("");
  const [prenomTut, setPrenomTut] = useState("");
  const [cinTut, setcinTut] = useState("");
  const [dateNaissanceTut, setDateNaissanceTut] = useState(null);
  const [telephoneTut, setTelephoneTut] = useState("");
  const [selectedCenterEnf, setSelectedCenterEnf] = useState(null);
  const [isNewTuteur, setIsNewTuteur] = useState(false);
  const [showAlertNoEmplExistEnf, setShowAlertNoEmplExistEnf] = useState(false);
  const [isLoadingEnf, setIsLoadingEnf] = useState(false);
  const [selectedDateEnf, setSelectedDateEnf] = useState(new Date());
  const [disabledDatesEnf, setDisabledDatesEnf] = useState([]);
  const [disabledTimesEnf, setDisabledTimesEnf] = useState({});
  const [selectedTimeEnf, setSelectedTimeEnf] = useState(null);
  const [centersEnf, setCentersEnf] = useState([]);

  const [isLoadingSubmitEnf, setIsLoadingSubmitEnf] = useState(false);

  const [isCentersDisabledEnf, setIsCentersDisabledEnf] = useState(true);

  // State to store the selected mode
  const [selectedModeEnf, setSelectedModeEnf] = useState(null);
  const [selectedVilleEnf, setSelectedVilleEnf] = useState(null);

  const handleTelephoneTutChange = (e) => {
    const input = e.target.value.replace(/\D/g, ""); // Removes all non-digit characters
    if (input.length <= 9) {
      // Ensures no more than 9 digits can be input
      setTelephoneTut(input);
    }
  };

  const handleVilleEnfChange = (option) => {
    setSelectedVilleEnf(option);
    setSelectedCenterEnf(null);
    setCentersEnf([]);
    setIsCentersDisabledEnf(true);
  };

  //Femme Part

  const modes = [
    { value: "En ligne", label: t('modes.online') },
    { value: "Physique", label: t('modes.physical') },
  ];

  const [currentStep, setCurrentStep] = useState(1);
  // const [dateNaissance, setDateNaissance] = useState(null);
  const [dateNaissance, setDateNaissance] = useState(null); // State for managing date
  const today = new Date();
  const [telephone, setTelephone] = useState("");

  const [nom, setNom] = useState("");
  const [prenom, setPrenom] = useState("");
  const [cin, setCin] = useState("");
  const [villes, setVilles] = useState([]);
  const [centers, setCenters] = useState([]);
  const [selectedVille, setSelectedVille] = useState(null);
  const [selectedCenter, setSelectedCenter] = useState(null);
  const [isCentersDisabled, setIsCentersDisabled] = useState(true);
  var [isNewCitoyen, setIsNewCitoyen] = useState(false);

  // State to store the selected mode
  const [selectedMode, setSelectedMode] = useState(modes[1]);

  const [showAlertNoEmplExist, setShowAlertNoEmplExist] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [disabledDates, setDisabledDates] = useState([]);
  const [disabledTimes, setDisabledTimes] = useState({});
  const [selectedTime, setSelectedTime] = useState(null);

  const [FirstStepErrorMessage, setFirstStepErrorMessage] = useState("");

  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);

  const [inputValue, setInputValue] = useState(null);


  
  // Handle manual input change
  const handleInputChange = (e) => {
    const value = e.target.value; // Get the input value
    const parts = value.split("/"); // Split the input by slashes

    // Validate month part to ensure it's between 01 and 12
    if (parts.length > 1 && parts[1].length === 2) {
      const month = parseInt(parts[1], 10); // Convert month to integer
      if (month < 0 || month > 12) {
        return; // If month is not valid, do nothing
      }
    }

    setInputValue(value); // Update input value state

    // If the input is valid, update the dateNaissance state
    const parsedDate = parse(value, "dd/MM/yyyy", new Date());
    if (isValid(parsedDate)) {
      setDateNaissance(parsedDate);
    } else {
      setDateNaissance(null); // or handle the invalid case appropriately
    }
  };

  const handleTelephoneChange = (e) => {
    const input = e.target.value.replace(/\D/g, ""); // Removes all non-digit characters
    if (input.length <= 9) {
      // Ensures no more than 9 digits can be input
      setTelephone(input);
    }
  };

  // Fetch villes on component mount
  useEffect(() => {
    fetch(`${ApiUrl}all-villes`)
      .then((response) => response.json())
      .then((data) => {
        const options = data.map((ville) => ({ value: ville, label: ville }));
        setVilles(options);
      })
      .catch((error) => console.error("Error fetching villes:", error));
  }, []);

  // Fetch centers when a ville is selected
  useEffect(() => {
    if (selectedVille) {
      fetch(`${ApiUrl}centers/${selectedVille.value}`)
        .then((response) => response.json())
        .then((data) => {
          const options = data.map((center) => ({
            value: center.id, // Use the center's ID as the value
            label: center.name, // Use the center's name as the label
          }));

          setCenters(options);
          setIsCentersDisabled(false); // Enable the centers select
        })
        .catch((error) => console.error("Error fetching centers:", error));
    }
    if (selectedVilleEnf) {
      fetch(`${ApiUrl}centers/${selectedVilleEnf.value}`)
        .then((response) => response.json())
        .then((data) => {
          const options = data.map((center) => ({
            value: center.id, // Use the center's ID as the value
            label: center.name, // Use the center's name as the label
          }));

          setCentersEnf(options);
          setIsCentersDisabledEnf(false); // Enable the centers select
        })
        .catch((error) => console.error("Error fetching centers:", error));
    } else {
      // Reset centers and disable the select if no ville is selected
      setCenters([]);
      setIsCentersDisabled(true);
      setCentersEnf([]);
      setIsCentersDisabledEnf(true);
    }
  }, [selectedVille, selectedVilleEnf]);

  // Update the selected ville and reset selected center
  const handleVilleChange = (option) => {
    setSelectedVille(option);
    setSelectedCenter(null);
    setCenters([]);
    setIsCentersDisabled(true);
  };

  //Page 2

  const selectTime = (time) => {
    setSelectedTime(time);
  };

  const handleTimeSelect = (event, time) => {
    // Prevent default action for all links
    event.preventDefault();

    // Stop the event from propagating (in case of nested elements)
    event.stopPropagation();

    // If the time is disabled, do nothing more
    if (isTimeDisabled(time)) {
      return;
    }
    // Proceed with selecting the time if it is not disabled
    selectTime(time);
    setSelectedTime(time);
  };

  const selectTimeEnf = (time) => {
    setSelectedTimeEnf(time);
  };

  const handleTimeSelectEnf = (event, time) => {
    // Prevent default action for all links
    event.preventDefault();

    // Stop the event from propagating (in case of nested elements)
    event.stopPropagation();

    // If the time is disabled, do nothing more
    if (isTimeDisabledEnf(time)) {
      return;
    }

    // Proceed with selecting the time if it is not disabled
    selectTimeEnf(time);
    setSelectedTimeEnf(time);
  };

  const formattedDate = selectedDate
    ? format(new Date(selectedDate), "dd/M/yyyy")
    : "";
  useEffect(() => {
    async function fetchFullyBookedDays() {
      setIsLoading(true); // Begin loading
      setDisabledDates([]);
      setDisabledTimes({});
      try {
        if (selectedCenter && selectedCenter.value) {
          const response = await fetch(
            `${ApiUrl}fetchSchedules/${selectedCenter.value}`
          );
          if (!response.ok) {
            if (response.status === 404) {
              setShowAlertNoEmplExist(true);
              console.log("No Employee Found");
            }
            setIsLoading(false);
            return; // Exit early
          } else {
            setShowAlertNoEmplExist(false);
          }
          const data = await response.json();

          console.log(data.partialScheduleFully);

          const bookedDates = data.fullyBookedDays.map((day) => new Date(day));
          setDisabledDates(bookedDates);

          if (data.partialScheduleFully && selectedDate) {
            console.log(data.partialScheduleFully);
            console.log(selectedDate);

            //const formattedDate = selectedDate.toISOString().split("T")[0];
            const formattedDate = selectedDate.toLocaleDateString("en-CA");
            console.log("formattedDate" + formattedDate);

            const times = data.partialScheduleFully[formattedDate] || {};
            console.log(times);

            setDisabledTimes(times);
            console.log(times);
          }
        }
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false); // Ensure loading is ended regardless of outcome
      }
    }

    async function fetchFullyBookedDaysEnf() {
      setIsLoadingEnf(true);
      setDisabledDatesEnf([]);
      setDisabledTimesEnf({});
      try {
        if (selectedCenterEnf && selectedCenterEnf.value) {
          const response = await fetch(
            `${ApiUrl}fetchSchedules/${selectedCenterEnf.value}`
          );
          if (!response.ok) {
            if (response.status === 404) {
              setShowAlertNoEmplExistEnf(true);
              console.log("No Employee Found");
            }
            setIsLoadingEnf(false); // End loading if there's an error
            return; // Exit early
          } else {
            setShowAlertNoEmplExistEnf(false);
          }
          const data = await response.json();

          const bookedDates = data.fullyBookedDays.map((day) => new Date(day));
          setDisabledDatesEnf(bookedDates);

          if (data.partialScheduleFully && selectedDate) {
            const formattedDate = selectedDate.toISOString().split("T")[0];
            const times = data.partialScheduleFully[formattedDate] || {};
            setDisabledTimesEnf(times);
          }
        }
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoadingEnf(false); // Ensure loading is ended regardless of outcome
      }
    }

    if (selectedCenter && selectedCenter.value) {
      fetchFullyBookedDays();
    }
    if (selectedCenterEnf && selectedCenterEnf.value) {
      fetchFullyBookedDaysEnf();
    }
  }, [selectedCenter, selectedDate, selectedCenterEnf, selectedDateEnf]);

  const convertTime12to24 = (time12h) => {
    const [time, modifier] = time12h.split(" ");
    let [hours, minutes] = time.split(":");

    if (hours === "12") {
      hours = "00";
    }
    if (modifier === "PM") {
      hours = parseInt(hours, 10) + 12;
    }
    return `${hours}:${minutes}:00`;
  };

  const generateTimeSlots = (start, end) => {
    const startTime = moment(start, "HH:mm");
    const endTime = moment(end, "HH:mm");
    const timeSlots = [];

    while (startTime <= endTime) {
      timeSlots.push(startTime.format("HH:mm")); // Including seconds to match your initial format
      startTime.add(30, "minutes");
    }

    return timeSlots;
  };

  // Generate slots from "08:00" to "19:30" (24-hour format)
  const times = generateTimeSlots("09:00", "18:30");

  const isTimeDisabled = (time) => {
    const formattedTime = convertTime12to24(time); // Convert "09:00 AM" to "09:00:00"
    return disabledTimes[formattedTime];
  };

  const isTimeDisabledEnf = (time) => {
    const formattedTime = convertTime12to24(time);
    return disabledTimesEnf[formattedTime];
  };

  const onDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleDateChange = (date) => {
    // If the date is valid, format it back to the input value
    if (isValid(date)) {
      setDateNaissance(date);
      const formattedDate = format(date, "dd/MM/yyyy");
      setInputValue(formattedDate); // Update input value for the DatePicker
    } else {
      setInputValue(""); // Clear input if invalid
    }
  };

  const isWeekday = (date) => {
    const day = getDay(date); // Get the day of the week (0 for Sunday, 6 for Saturday)
    //console.log(`Checking date: ${date}, Day: ${day}`); // Debugging log
    return day !== 0 && day !== 6;
  };
  //page

  const handleFirstNextStep = (e) => {
    e.preventDefault();
    if (!checkAge(dateNaissance)) {
      setFirstStepErrorMessage(
        "Vous devez avoir au moins 18 ans pour continuer."
      );
      return;
    }
    // Proceed to the next step if the user is 18+
    setCurrentStep(currentStep + 1);
    setFirstStepErrorMessage("");
  };

  const submitAppointmentData = async (formData) => {
    setIsLoadingSubmit(true);
    try {
      const response = await fetch(
         `${ApiUrl}femme-add-rdv`,
     //   "https://backend03.hnam3ak.ma/api/femme-add-rdv",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          // withXSRFToken: true,
          // withCredentials: true,
          body: JSON.stringify(formData),
        }
      );

      if (!response.ok) {
        // Check if the server response is not OK (status is not in the range 200-299)
        const errorData = await response.json(); // Assuming the server responds with JSON on errors
        throw new Error(
          `HTTP error ${response.status}: ${JSON.stringify(errorData)}`
        );
      }

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();
      setIsLoadingSubmit(false);
      setIsNewCitoyen(data.is_new_citoyen);
      return data;
    } catch (error) {
      console.error("Failed to submit appointment data:", error);
      throw error;
    }
  };
  const navigate = useNavigate();
  const handleFinalSubmit = async (event) => {
    event.preventDefault();
    const formattedDateNaissance = format(dateNaissance, "yyyy-MM-dd");
    const formattedDateRDV = format(selectedDate, "yyyy-MM-dd");

    const formData = {
      nom,
      prenom,
      cin,
      date_naissance: formattedDateNaissance,
      center_id: selectedCenter ? selectedCenter.value : null,
      date_rdv: formattedDateRDV,
      type_rdv: selectedMode ? selectedMode.value : null,
      heure_rdv: selectedTime + ":00",
      telephone: "+212" + telephone,
    };

    try {
      const result = await submitAppointmentData(formData);
      console.log("Appointment booked successfully:", result);
      //console.log("isNewCitoyen:", isNewCitoyen);*
      // setIsNewCitoyen(result.is_new_citoyen);
      isNewCitoyen = result.is_new_citoyen;
      navigate("/connect-message", {
        state: { isNewCitoyen: result.is_new_citoyen },
      });
      // setCurrentStep(currentStep + 1);
    } catch (error) {
      console.error("Error booking appointment:", error);
      // Handle errors such as displaying a message to the user
    }
  };

  const submitAppointmentDataEnfant = async (formData) => {
    setIsLoadingSubmitEnf(true);
    try {
      const response = await fetch(
         `${ApiUrl}enf-add-rdv`,
       // "https://backend03.hnam3ak.ma/api/enf-add-rdv",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json", // Assuming your API returns JSON
          },
          body: JSON.stringify(formData), // Convert JavaScript object to JSON string
        }
      );

      if (!response.ok) {
        // Check if the server response is not OK (status is not in the range 200-299)
        const errorData = await response.json(); // Assuming the server responds with JSON on errors
        throw new Error(
          `HTTP error ${response.status}: ${JSON.stringify(errorData)}`
        );
      }

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();
      setIsLoadingSubmitEnf(false);
      setIsNewTuteur(data.is_new_tuteur);
      return data;
    } catch (error) {
      console.error("Failed to submit appointment data:", error);
      throw error;
    }
  };

  const handleFinalSubmitEnf = async (event) => {
    event.preventDefault();
    const formattedDateNaissanceEnfant = format(dateNaissanceEnf, "yyyy-MM-dd");
    const formattedDateNaissanceTuteur = format(dateNaissanceTut, "yyyy-MM-dd");
    const formattedDateRDVEnf = format(
      addDays(selectedDateEnf, 1),
      "yyyy-MM-dd"
    );

    const formData = {
      nomEnf,
      preEnf: prenomEnf,
      genreEnf: selectedGendre.value,
      dateNaissanceEnf: formattedDateNaissanceEnfant,
      cinTut,
      dateNaissanceTut: formattedDateNaissanceTuteur,
      nomTut,
      prenomTut,
      centre_id: selectedCenterEnf ? selectedCenterEnf.value : null,
      date_rdv: formattedDateRDVEnf,
      type_rdv: selectedModeEnf ? selectedModeEnf.value : null,
      heure_rdv: selectedTimeEnf + ":00",
      phoneTut: "+212" + telephoneTut,
    };

    try {
      //console.log(formData.date_rdv);
      const result = await submitAppointmentDataEnfant(formData);
      console.log("Appointment booked successfully:", result);
      // isNewTuteur = result.is_new_tuteur;
      // navigate("/connect-message", {
      //   state: { isNewTuteur: result.is_new_tuteur },
      // });
      // setCurrentStepEnf(currentStepEnf + 1);
    } catch (error) {
      console.error("Error booking appointment:", error);
      // Handle errors such as displaying a message to the user
    }
  };
  return (
    <>
      {/*================= counter area start {/*=================*/}
      <div
        id="contact-section"
        className="contact-area  pd-top-90 pd-bottom-120 "
      >
        <div className="container">
          <div className="row bg-gray" style={{ borderRadius: "20px" }}>
            <div
              className="col-lg-12 order-lg-first"
              data-aos="fade-right"
              data-aos-delay="200"
              data-aos-duration="1500"
            >
              <div style={{ margin: "auto", width: "90%" }}>
                <div className="section-title mb-0 mt-5 mt-lg-0">
                  <div className="">
                    <nav className="text-center">
                      <div
                        className="nav nav-tabs career-nav-tab justify-content-center"
                        id="nav-tab"
                        role="tablist"
                      >
                        <button
                          className="nav-link active"
                          id="nav-mission-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#nav-mission"
                          type="button"
                          role="tab"
                          aria-controls="nav-mission"
                          aria-selected="true"
                        >
                          {t("form.femme")}
                        </button>
                        <button
                          className="nav-link"
                          id="nav-vision-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#nav-vision"
                          type="button"
                          disabled
                          role="tab"
                          aria-controls="nav-vision"
                          aria-selected="false"
                        >
                          {t("form.enfant")}
                        </button>
                      </div>
                    </nav>
                    <div className="tab-content" id="nav-tabContent">
                      <div
                        className="tab-pane fade show active"
                        id="nav-mission"
                        role="tabpanel"
                        aria-labelledby="nav-mission-tab"
                      >
                        <div className="career-wrap">
                          <h5 className="title text-center">
                            {t("form.declare")}{" "}
                            <span>{t("form.violence")}</span> {t("form.now")}
                          </h5>

                          {currentStep === 1 && (
                            <form className="mt-1">
                              <aside class="MuiCallout-root MuiCallout-info">
                                <FaInfoCircle
                                  style={{
                                    alignSelf: "center",
                                    marginRight: "1%",
                                  }}
                                />
                                <div class="MuiCallout-content">
                                  <p>
                                    <p>{t("form.alert.fillFields")}</p>
                                  </p>
                                </div>
                              </aside>
                              {showAlertNoEmplExist && (
                                <aside className="MuiCallout-root MuiCallout-error">
                                  <div className="MuiCallout-content">
                                    <p>
                                      <strong>
                                        {t("form.alert.sorryTitle")}
                                      </strong>
                                    </p>
                                    <p>
                                      {t("form.alert.serviceUnavailable")}{" "}
                                      <a href="tel:+212661453687">
                                        +212 (6) 61453687
                                      </a>
                                    </p>
                                  </div>
                                </aside>
                              )}
                              <p className="content mt-4">
                                {t("form.personalInfo")}
                              </p>
                              <div className="row mt-2">
                                {/* Display error message */}
                                {FirstStepErrorMessage && (
                                  <div className="alert alert-danger">
                                    {FirstStepErrorMessage}
                                  </div>
                                )}
                              </div>

                              <div className="row mt-3">
                                <div className="col-lg-6">
                                  <div className="form-input single-input-inner style-border">
                                    <input
                                      type="text"
                                      placeholder={t('form.nom')}
                                      value={nom}
                                      onChange={(e) => setNom(e.target.value)}
                                    />
                                    {/* <p className="text-danger">Champ obligatoire</p> */}
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="form-input single-input-inner style-border">
                                    <input
                                      type="text"
                                      placeholder={t('form.prenom')}
                                      value={prenom} // Bind state variable
                                      onChange={(e) =>
                                        setPrenom(e.target.value)
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="form-input single-input-inner style-border">
                                    <input
                                      type="text"
                                      placeholder={t('form.cin')}
                                      value={cin} // Bind state variable
                                      onChange={(e) => setCin(e.target.value)}
                                    />
                                  </div>
                                </div>

                                <div className="col-lg-6">
                                  <div className="form-input single-input-inner style-border">
                                    <DatePicker
                                      selected={dateNaissance}
                                      onChange={handleDateChange}
                                      customInput={
                                        <InputMask
                                          mask="dd/mm/yyyy"
                                          className="custom-datepicker2 react-datepicker-ignore-onclickoutside"
                                          replacement={{
                                            d: /\d/,
                                            m: /\d/,
                                            y: /\d/,
                                          }}
                                          separate
                                          value={inputValue}
                                          onChange={handleInputChange}
                                        />
                                      }
                                      dateFormat="dd/MM/yyyy"
                                      showPopperArrow={true}
                                      placeholderText={t('form.dateNaissance')}
                                    />
                                  </div>
                                </div>

                                <div className="col-lg-12">
                                  <div className="form-input single-input-inner style-border">
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        position: "relative",
                                      }}
                                    >
                                      <span
                                        className="me-4"
                                        style={{
                                          position: "absolute",
                                          left: 10,
                                          pointerEvents: "none",
                                          color: "#555",
                                        }}
                                      >
                                        +212
                                      </span>
                                      <input
                                        type="tel"
                                        placeholder={`    ${t('form.telephone')}`}
                                        value={telephone}
                                        onChange={handleTelephoneChange}
                                        style={{
                                          flex: 1,
                                          paddingLeft: "50px", // Make room for the "+212" to display
                                          border: "none", // Remove default input border
                                          outline: "none", // Remove focus outline
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>

                                <div className="col-lg-12">
                                  <div className="form-input single-input-inner style-border">
                                    <Select
                                      value={selectedVille}
                                      onChange={handleVilleChange}
                                      options={villes}
                                      placeholder={t('form.ville')}
                                      isSearchable={true}
                                      styles={{
                                        control: (base) => ({
                                          ...base,
                                          borderRadius: "10px", // Apply border radius here
                                          boxShadow: "none", // Optional: Remove box shadow
                                          "&:hover": {},
                                        }),
                                      }}
                                    />
                                  </div>
                                </div>
                                <div className="col-lg-12">
                                  <div className="form-input single-input-inner style-border">
                                    <Select
                                      value={selectedCenter}
                                      onChange={setSelectedCenter}
                                      options={centers}
                                      placeholder={t('form.center')}
                                      isSearchable={true}
                                      isDisabled={isCentersDisabled}
                                      styles={{
                                        control: (base) => ({
                                          ...base,
                                          borderRadius: "10px",
                                          boxShadow: "none",

                                          "&:hover": {},
                                        }),
                                      }}
                                    />
                                  </div>
                                </div>
                                <div className="col-12">
                                  <button
                                    className="btn btn-black mt-0"
                                    onClick={handleFirstNextStep}
                                    disabled={
                                      isLoading ||
                                      showAlertNoEmplExist ||
                                      !selectedCenter ||
                                      !selectedVille ||
                                      !nom ||
                                      !prenom ||
                                      !cin ||
                                      !dateNaissance ||
                                      !telephone
                                    }
                                    Disables
                                    button
                                    during
                                    loading
                                    or
                                    if
                                    any
                                    condition
                                    is
                                    not
                                    met
                                  >
                                     {t('buttons.next')} <FaArrowRight />
                                  </button>
                                </div>
                              </div>
                            </form>
                          )}

                          {currentStep === 2 && (
                            <form className="mt-4">
                              <aside class="MuiCallout-root MuiCallout-info">
                                <FaInfoCircle
                                  style={{
                                    alignSelf: "center",
                                    marginRight: "1%",
                                  }}
                                />
                                <div class="MuiCallout-content">
                                  <p>
                                    {t('form.alert.fillFields')}
                                  </p>
                                </div>
                              </aside>
                              <div className="col-12">
                                <div className="row">
                                  <div className="col-6">
                                    <p className="content mb-2">
                                      {t('form.chooseMode')}
                                    </p>

                                    <Select
                                      value={selectedMode}
                                      onChange={setSelectedMode}
                                      options={modes}
                                       placeholder={t('form.selectMode')}
                                      isSearchable={false}
                                    />
                                  </div>
                                  <div className="col-6">
                                     <p className="content mb-2">{t('form.chosenDate')}</p>
                                    <div className="custom-gray-alert">
                                      <span className="align-self-center">
                                        {formattedDate}
                                      </span>
                                    </div>
                                  </div>
                                </div>

                                <DatePicker
                                  className="custom-datepicker mt-5"
                                  dateFormat="MMMM d, yyyy"
                                  selected={selectedDate}
                                  onChange={onDateChange}
                                  inline={true}
                                  minDate={today}
                                  calendarClassName="custom-calendar-1"
                                  filterDate={isWeekday}
                                  excludeDates={disabledDates}
                                  locale={fr}
                                />
                              </div>
                              <div className="col-12 d-flex mt-3">
                                <button
                                  className="btn btn-border-gray mt-0 me-3"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setCurrentStep(currentStep - 1);
                                  }}
                                >
                                  <FaArrowLeft /> {t('buttons.previous')}
                                </button>
                                <button
                                  className="btn btn-black mt-0"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setCurrentStep(currentStep + 1);
                                  }}
                                  disabled={!selectedDate}
                                >
                                   {t('buttons.next')} <FaArrowRight />
                                </button>
                              </div>
                            </form>
                          )}
                          {currentStep === 3 && (
                            <form className="mb-4">
                              <aside class="MuiCallout-root MuiCallout-info">
                                <FaInfoCircle
                                  style={{
                                    alignSelf: "center",
                                    marginRight: "1%",
                                  }}
                                />
                                <div class="MuiCallout-content">
                                  <p>
                                    {t('form.alert.fillFields')}
                                  </p>
                                </div>
                              </aside>
                              <p className="content mb-2">
                                  {t('form.choose_hour')}
                              </p>
                              <h6>
                                {t('form.selected_hour')} :   {selectedTime || t('form.no_hour_selected')}
                              </h6>

                              <div className="col-12">
                                <div className="mb-4">
                                  <div className="card-body">
                                    <div className="d-flex flex-wrap gap-1">
                                      {times.map((time) => (
                                        <button
                                          key={time}
                                          className={`card time-slot ${
                                            isTimeDisabled(time)
                                              ? "disabled"
                                              : ""
                                          }`}
                                          style={{
                                            width: "110px",
                                            height: "50px",
                                            justifyContent: "center",
                                            cursor: isTimeDisabled(time)
                                              ? "not-allowed"
                                              : "pointer",
                                            opacity: isTimeDisabled(time)
                                              ? 0.5
                                              : 1,
                                          }}
                                          onClick={(event) =>
                                            !isTimeDisabled(time) &&
                                            handleTimeSelect(event, time)
                                          }
                                          disabled={isTimeDisabled(time)}
                                          aria-disabled={
                                            isTimeDisabled(time)
                                              ? "true"
                                              : "false"
                                          }
                                        >
                                          <div className="card-body">
                                            {time}
                                          </div>
                                        </button>
                                      ))}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-12 d-flex">
                                <button
                                  className="btn btn-border-gray mt-0 me-3"
                                  href="#"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setCurrentStep(currentStep - 1);
                                  }}
                                >
                                  Précédent <FaMinusCircle />
                                </button>
                                <button
                                  className="btn btn-black mt-0"
                                  href="#"
                                  onClick={handleFinalSubmit}
                                  disabled={!selectedTime}
                                >
                                  {isLoadingSubmit ? (
                                    <span className="d-flex">
                                      <svg
                                        stroke="currentColor"
                                        fill="white"
                                        strokeWidth="0"
                                        viewBox="0 0 512 512"
                                        class="btn-spinner-svg "
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"></path>
                                      </svg>
                                      Envoi en cours
                                    </span>
                                  ) : (
                                    <span>
                                      Envoyer <FaArrowRight />
                                    </span>
                                  )}
                                </button>
                              </div>
                            </form>
                          )}
                          {currentStep === 4 && <ConnectMessage />}
                        </div>
                      </div>
                      <div
                        className="tab-pane fade"
                        id="nav-vision"
                        role="tabpanel"
                        aria-labelledby="nav-vision-tab"
                      >
                        <div className="career-wrap">
                          <div className="row">
                            {currentStepEnf === 1 && (
                              <form className="mt-1">
                                <aside class="MuiCallout-root MuiCallout-info">
                                  <FaInfoCircle
                                    style={{
                                      alignSelf: "center",
                                      marginRight: "1%",
                                    }}
                                  />
                                  <div class="MuiCallout-content">
                                    <p>
                                      Remplissez tous les champs pour passer à
                                      l'étape suivante
                                    </p>
                                  </div>
                                </aside>
                                {showAlertNoEmplExistEnf && (
                                  <aside className="MuiCallout-root MuiCallout-error">
                                    <div className="MuiCallout-content">
                                      <p>
                                        <strong>Nous sommes désolés ! </strong>
                                      </p>
                                      <p>
                                        Actuellement, nos services ne sont pas
                                        disponibles dans ce centre, en raison de
                                        l'absence d'un assistant social. Nous
                                        vous invitons à sélectionner un autre
                                        centre. Pour plus d'information appeler
                                        le numéro{" "}
                                        <a href="tel:+212661453687">
                                          +212 (6) 61453687
                                        </a>
                                      </p>
                                    </div>
                                  </aside>
                                )}
                                <p className="content mt-4">
                                  Informations personnelle
                                </p>

                                <div className="row mt-3">
                                  <div className="col-lg-6">
                                    <div className="form-input single-input-inner style-border">
                                      <input
                                        type="text"
                                        placeholder="Nom de L'enfant"
                                        value={nomEnf}
                                        onChange={(e) =>
                                          setNomEnf(e.target.value)
                                        }
                                      />
                                      {/* <p className="text-danger">Champ obligatoire</p> */}
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="form-input single-input-inner style-border">
                                      <input
                                        type="text"
                                        placeholder="Prénom de L'enfant"
                                        value={prenomEnf} // Bind state variable
                                        onChange={(e) =>
                                          setPrenomEnf(e.target.value)
                                        }
                                      />
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <Select
                                      styles={{ padding: "1px" }}
                                      value={selectedGendre}
                                      onChange={setSelectedGendre}
                                      options={gendres}
                                      placeholder="Genre"
                                      isSearchable={true}
                                    />
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="form-input single-input-inner style-border">
                                      <DatePicker
                                        selected={dateNaissanceEnf}
                                        onChange={(date) =>
                                          setDateNaissanceEnf(date)
                                        }
                                        dateFormat="dd/MM/yyyy"
                                        className="form-control custom-datepicker2 react-datepicker-ignore-onclickoutside"
                                        placeholderText="dd/mm/yyyy"
                                        calendarClassName="custom-calendar-2"
                                        locale={fr}
                                      />
                                    </div>
                                  </div>

                                  <div className="col-lg-12">
                                    <div className="form-input single-input-inner style-border">
                                      <Select
                                        value={selectedVilleEnf}
                                        onChange={handleVilleEnfChange}
                                        options={villes}
                                        placeholder="Select a ville"
                                        isSearchable={true}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-lg-12">
                                    <div className="form-input single-input-inner style-border">
                                      <Select
                                        value={selectedCenterEnf}
                                        onChange={setSelectedCenterEnf}
                                        options={centersEnf}
                                        placeholder="Select a center"
                                        isSearchable={true}
                                        isDisabled={isCentersDisabledEnf}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-12">
                                    <button
                                      className="btn btn-black mt-0"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        setCurrentStepEnf(currentStepEnf + 1);
                                      }}
                                      disabled={
                                        showAlertNoEmplExistEnf ||
                                        !selectedCenterEnf ||
                                        !selectedVilleEnf ||
                                        !nomEnf ||
                                        !prenomEnf ||
                                        !dateNaissanceEnf
                                      }
                                      Disables
                                      button
                                      during
                                      loading
                                      or
                                      if
                                      any
                                      condition
                                      is
                                      not
                                      met
                                    >
                                      Suivant <FaArrowRight />
                                    </button>
                                  </div>
                                </div>
                              </form>
                            )}

                            {currentStepEnf === 2 && (
                              <form className="mt-1">
                                <aside class="MuiCallout-root MuiCallout-info">
                                  <FaInfoCircle
                                    style={{
                                      alignSelf: "center",
                                      marginRight: "1%",
                                    }}
                                  />
                                  <div class="MuiCallout-content">
                                    <p>
                                      Remplissez tous les champs pour passer à
                                      l'étape suivante
                                    </p>
                                  </div>
                                </aside>
                                <p className="content mt-4">
                                  Informations Tuteur
                                </p>

                                <div className="row mt-3">
                                  <div className="col-lg-6">
                                    <div className="form-input single-input-inner style-border">
                                      <input
                                        type="text"
                                        placeholder="Nom de Tuteur"
                                        value={nomTut}
                                        onChange={(e) =>
                                          setNomTut(e.target.value)
                                        }
                                      />
                                      {/* <p className="text-danger">Champ obligatoire</p> */}
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="form-input single-input-inner style-border">
                                      <input
                                        type="text"
                                        placeholder="Prénom de Tuteur"
                                        value={prenomTut} // Bind state variable
                                        onChange={(e) =>
                                          setPrenomTut(e.target.value)
                                        }
                                      />
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="form-input single-input-inner style-border">
                                      <input
                                        type="text"
                                        placeholder="CIN de Tuteur"
                                        value={cinTut} // Bind state variable
                                        onChange={(e) =>
                                          setcinTut(e.target.value)
                                        }
                                      />
                                    </div>
                                  </div>

                                  <div className="col-lg-6">
                                    <div className="form-input single-input-inner style-border">
                                      <DatePicker
                                        selected={dateNaissanceTut}
                                        onChange={(date) =>
                                          setDateNaissanceTut(date)
                                        }
                                        dateFormat="dd/MM/yyyy"
                                        className="form-control custom-datepicker2 react-datepicker-ignore-onclickoutside"
                                        placeholderText="dd/mm/yyyy"
                                        calendarClassName="custom-calendar-2"
                                        locale={fr}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-lg-12">
                                    <div className="form-input single-input-inner style-border">
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          position: "relative",
                                        }}
                                      >
                                        <span
                                          className="me-4"
                                          style={{
                                            position: "absolute",
                                            left: 10,
                                            pointerEvents: "none",
                                            color: "#555",
                                          }}
                                        >
                                          +212
                                        </span>
                                        <input
                                          type="tel"
                                          placeholder="    N° de téléphone"
                                          value={telephoneTut}
                                          onChange={handleTelephoneTutChange}
                                          style={{
                                            flex: 1,
                                            paddingLeft: "50px", // Make room for the "+212" to display
                                            border: "none", // Remove default input border
                                            outline: "none", // Remove focus outline
                                          }}
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-12">
                                    <button
                                      className="btn btn-black mt-4"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        setCurrentStepEnf(currentStepEnf + 1);
                                      }}
                                      disabled={
                                        !nomTut ||
                                        !prenomTut ||
                                        !cinTut ||
                                        !dateNaissanceTut ||
                                        !telephoneTut
                                      }
                                      Disables
                                      button
                                      during
                                      loading
                                      or
                                      if
                                      any
                                      condition
                                      is
                                      not
                                      met
                                    >
                                      Suivant <FaArrowRight />
                                    </button>
                                  </div>
                                </div>
                              </form>
                            )}

                            {currentStepEnf === 3 && (
                              <form className="mt-4">
                                <aside class="MuiCallout-root MuiCallout-info">
                                  <FaInfoCircle
                                    style={{
                                      alignSelf: "center",
                                      marginRight: "1%",
                                    }}
                                  />
                                  <div class="MuiCallout-content">
                                    <p>
                                      Remplissez tous les champs pour passer à
                                      l'étape suivante
                                    </p>
                                  </div>
                                </aside>
                                <div className="col-12">
                                  <div className="row">
                                    <div className="col-6">
                                      <p className="content mb-2">
                                        Choisissez une mode
                                      </p>

                                      <Select
                                        value={selectedModeEnf}
                                        onChange={setSelectedModeEnf}
                                        options={modes}
                                        placeholder="Séléctionnez un mode"
                                        isSearchable={false}
                                      />
                                    </div>
                                    <div className="col-6">
                                      <p className="content mb-2">
                                        Date choisie
                                      </p>
                                      <div className="custom-gray-alert">
                                        <span className="align-self-center">
                                          {formattedDate}
                                        </span>
                                      </div>
                                    </div>
                                  </div>

                                  <DatePicker
                                    className="custom-datepicker mt-5"
                                    dateFormat="MMMM d, yyyy"
                                    selected={selectedDateEnf}
                                    onChange={onDateChange}
                                    inline={true}
                                    minDate={today}
                                    calendarClassName="custom-calendar-1"
                                    excludeDates={disabledDatesEnf}
                                    locale={fr}
                                    filterDate={isWeekday}
                                  />
                                </div>
                                <div className="col-12 d-flex mt-3">
                                  <button
                                    className="btn btn-border-gray mt-0 me-3"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      setCurrentStepEnf(currentStepEnf - 1);
                                    }}
                                  >
                                    <FaArrowLeft /> Précédent
                                  </button>
                                  <button
                                    className="btn btn-black mt-0"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      setCurrentStepEnf(currentStepEnf + 1);
                                    }}
                                    disabled={!selectedDateEnf}
                                  >
                                    Suivant <FaArrowRight />
                                  </button>
                                </div>
                              </form>
                            )}
                            {currentStepEnf === 4 && (
                              <form className="mb-4">
                                <aside class="MuiCallout-root MuiCallout-info">
                                  <FaInfoCircle
                                    style={{
                                      alignSelf: "center",
                                      marginRight: "1%",
                                    }}
                                  />
                                  <div class="MuiCallout-content">
                                    <p>
                                      Remplissez tous les champs pour passer à
                                      l'étape suivante
                                    </p>
                                  </div>
                                </aside>
                                <p className="content mb-2">
                                  Choisissez une heure
                                </p>
                                <p>
                                  Selected Time:{" "}
                                  {selectedTimeEnf || "No time selected"}
                                </p>
                                <div className="col-12">
                                  <div className="mb-4">
                                    <div className="card-body">
                                      <div className="d-flex flex-wrap gap-1">
                                        {times.map((time) => (
                                          <button
                                            key={time}
                                            className={`card time-slot ${
                                              isTimeDisabledEnf(time)
                                                ? "disabled"
                                                : ""
                                            }`}
                                            style={{
                                              width: "110px",
                                              height: "50px",
                                              justifyContent: "center",
                                              cursor: isTimeDisabledEnf(time)
                                                ? "not-allowed"
                                                : "pointer",
                                              opacity: isTimeDisabledEnf(time)
                                                ? 0.5
                                                : 1,
                                            }}
                                            onClick={(event) =>
                                              !isTimeDisabledEnf(time) &&
                                              handleTimeSelectEnf(event, time)
                                            }
                                            disabled={isTimeDisabledEnf(time)}
                                            aria-disabled={
                                              isTimeDisabledEnf(time)
                                                ? "true"
                                                : "false"
                                            } // `aria-disabled` can still be useful for styling and semantic reasons
                                          >
                                            <div className="card-body">
                                              {time}
                                            </div>
                                          </button>
                                        ))}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-12 d-flex">
                                  <button
                                    className="btn btn-border-gray mt-0 me-3"
                                    href="#"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      setCurrentStepEnf(currentStepEnf - 1);
                                    }}
                                  >
                                    Précédent <FaMinusCircle />
                                  </button>
                                  <button
                                    className="btn btn-black mt-0"
                                    href="#"
                                    onClick={handleFinalSubmitEnf}
                                    disabled={!selectedTimeEnf}
                                  >
                                    {isLoadingSubmitEnf ? (
                                      <span className="d-flex">
                                        <svg
                                          stroke="currentColor"
                                          fill="white"
                                          strokeWidth="0"
                                          viewBox="0 0 512 512"
                                          class="btn-spinner-svg "
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"></path>
                                        </svg>
                                        Envoi en cours
                                      </span>
                                    ) : (
                                      <span>
                                        Envoyer <FaArrowRight />
                                      </span>
                                    )}
                                  </button>
                                </div>
                              </form>
                            )}

                            {currentStepEnf === 5 && <ConnectMessage />}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="contact-area pd-top-90 pd-bottom-120">
        <div className="container">
          <div className="row">
            <div
              className="col-lg-6 order-lg-end "
              data-aos="fade-left"
              data-aos-delay="200"
              data-aos-duration="1500"
            >
              <div className="about-thumb-inner ms-xl-5 p-xl-5 pt-4 ">
                <img
                  className="animate-main-img"
                  src="assets/img/about/18.png"
                  alt="img"
                />
                <img
                  className="main-img m-4"
                  src="assets/img/about/19.png"
                  alt="img"
                />
              </div>
            </div>
            <div
              className="col-lg-6 order-lg-first "
              data-aos="fade-right"
              data-aos-delay="200"
              data-aos-duration="1500"
            >
              <div className="section-title mb-0 mt-5 mt-lg-0">
                <h6 className="sub-title">GET IN TOUCH</h6>
                <h2 className="title">
                  Your Business To <span>Growth</span> Please Touch ?
                </h2>
                <p className="content">
                  For your car we will do everything advice design in us repairs
                  and maintenance. We are the some preferred.
                </p>
                <form className="mt-4">
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="form-input single-input-inner style-border">
                        <input type="text" placeholder="Name Here" />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-input single-input-inner style-border">
                        <input type="text" placeholder="Contact Here" />
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="form-input single-input-inner style-border">
                        <input type="text" placeholder="Email Here" />
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="form-input single-input-inner style-border">
                        <textarea placeholder="Message" defaultValue={''} />
                      </div>
                    </div>
                    <div className="col-12">
                      <Link className="btn btn-border-gray mt-0" to="#">
                        Contact Us <FaPlus />
                      </Link>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
};

export default ContactAreaFour;
